<template>
  <a
    v-if="callAction.length > 0"
    :href="callAction[0].itiLinkBtn1"
    target="_blank"
    class="cta-wrapper"
  >
    <div class="cta-container">

      <!-- IMAGEM REAL -->
      <img
        class="cta-image"
        :src="getImage(callAction[0])"
        alt="call to action"
      />

      <!-- overlay opcional -->
      <div class="cta-overlay">
        <div class="container">
          <div class="row justify-content-end">
            <div class="col-xl-6 col-lg-8 col-md-9 col-sm-12">
              <div class="single-emargency" v-show="false">
                <div class="emargency-cap">
                  <h5>{{ callAction[0].itiNome }}</h5>
                  <p v-html="callAction[0].itiResumo1"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </a>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PageCallAction',

  data() {
    return {
      callAction: [],
    };
  },

  created() {
    axios
      .get('/Process/InsInstitucional/institucional/19/callaction/0/x')
      .then(response => {
        this.callAction = response.data || [];
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    getImage(item) {
      return item?.insInstitucionalImagens?.[0]?.itgUrlImagem
        ? this.$imgURL + item.insInstitucionalImagens[0].itgUrlImagem
        : '';
    },
  },
};
</script>

<style scoped>
.cta-wrapper {
  display: block;
  width: 100%;
  text-decoration: none;
}

.cta-container {
  position: relative;
  width: 100%;
  height: clamp(120px, 22vw, 320px);
  background: #000; /* fundo para sobras */
  overflow: hidden;
}

/* 👇 ESSENCIAL */
.cta-image {
  width: 100%;
  height: 100%;
  /*object-fit: contain; /* NÃO CORTA */
  object-position: center;
}

/* overlay opcional */
.cta-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

/* MOBILE */
@media (max-width: 768px) {
  .cta-container {
    height: 110px;
  }

  .cta-image {
    object-fit: cover; /* pode preencher melhor no mobile */
  }
}
</style>